/**
* Uses Splide package to create a carousel for product media
 * More info: https://splidejs.com/
 */
class ProductMedia extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      slider: '[data-slider]',
    };
    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
      },
      instances: {
        slider: null,
      },
      options: {
        slider: {
          start: this.selectedMediaIndex,
          waitForTransition: false,
          gap: '2rem',
          arrows: false,
          pagination: true,
          mediaQuery: 'min',
          lazyLoad: 'nearby',
          preloadPages: 1,
          breakpoints: {
            768: {
              destroy: true
            }
          }
        }
      }
    };
  }

  connectedCallback() {
    this.selectedMediaIndex =
      Number(
        this.querySelector(this.selectors.slider)?.querySelector(
          '[data-selected]'
        )?.dataset.index
      ) || 0;

    this.init();

    this.querySelectorAll('.product__gallery-opener')
      .forEach((btn) => btn.addEventListener('click', () => this.classList.toggle('is-zoomed')));

    this.slides = {};
    this.querySelectorAll('.splide__slide').forEach((slide) => {
      const color = slide.querySelector('.product__image')?.dataset.color;
      if (color === 'js-shared-slide') {
        if (!!this.slides['sharedSlides']) {
          this.slides['sharedSlides'].push(slide);
          return;
        }

        this.slides['sharedSlides'] = [];
        this.slides['sharedSlides'].push(slide);
      }

      else if (color in this.slides) {
        this.slides[color].push(slide);
      }

      else {
        this.slides[color] = [];
        this.slides[color].push(slide);
      }
    });
  }

  init() {
    if (!this.settings.elements.slider)
      return;

    this.settings.instances.slider = new Splide(
      this.settings.elements.slider,
      this.settings.options.slider
    );

    this.settings.instances.slider.mount();
  }

  /**
   * Set active slide.
   *
   * @param {Number} id
   * @returns {Void}
   */
  setActiveSlide(id) {
    if (this.settings.instances.slider.state.is(Splide.STATES.DESTROYED)) {
      return;
    }

    const mediaFound =
      this.settings?.instances.slider?.Components.Elements.slides.find(
        slide => Number(slide.dataset.mediaId) === id
      );
    if (!mediaFound) return;
    this.settings.instances.slider.go(
      Number(mediaFound.dataset.index)
    );
  }

  filterByColor(color) {
    const filteredSlides = this.slides?.[color]?.concat(
      this.slides?.['sharedSlides'] || []
    );

    if (!filteredSlides) return;

    // On desktop (destroyed slider)
    if (this.settings.instances.slider.state.is(Splide.STATES.DESTROYED)) {
      this.querySelectorAll('.splide__slide').forEach((slide) => slide.remove());
      filteredSlides.forEach((slide) => {
        this.settings.instances.slider.Components.Elements.list.appendChild(slide)
      });
      return;
    }

    // On mobile
    this.settings.instances.slider.remove((slide) => slide);
    for (const slide of filteredSlides) {
      this.settings.instances.slider.add(slide);
    }

    this.settings.instances.slider.refresh();
    setTimeout(() => {
      this.settings.instances.slider.go(0);
    }, 100);
  }

  filterByVariant(position) {
    if (!this.settings.instances.slider.state.is(Splide.STATES.DESTROYED)) {
      return;
    }

    const slides = this.querySelectorAll('.splide__slide');
    if (slides[position - 1]) {
      slides.forEach((slide, index) => slide.classList.toggle('hidden', (index + 1) != position));
    } else {
      slides.forEach((slide) => slide.classList.remove('hidden'));
    }
  }
}

customElements.define('product-media', ProductMedia);
